module.exports = "img/flags/CU.9b6e992.png";